import { partition } from 'lodash';
import { IAchPushDisbursementData } from '../../../types/order/escrow/IAchPushDisbursementData';
import { IWireDepositData } from '../../../types/order/escrow/IWireDepositData';
import { ICheckDepositData } from '../../../types/order/escrow/ICheckDeposit';
import { IAchPullDepositData } from '../../../types/order/escrow/IAchPullDepositData';
import { IEscrowWireDisbursementsData } from '../../../types/order/escrow/IEscrowWireDisbursementsData';
import { IManualCheckDisbursementData } from '../../../types/order/escrow/IManualCheckDisbursementData';
import { IInternalTransferData } from '../../../types/order/escrow/IInternalTransferData';

interface INewAndUpdateTransactions<T> {
  newData: T[];
  updateData: T[];
}
// overloads
export function getNewAndUpdateTransactions(
  transactions?: IAchPullDepositData[]
): INewAndUpdateTransactions<IAchPullDepositData>;

export function getNewAndUpdateTransactions(
  transactions?: IAchPushDisbursementData[]
): INewAndUpdateTransactions<IAchPushDisbursementData>;

export function getNewAndUpdateTransactions(
  transactions?: ICheckDepositData[]
): INewAndUpdateTransactions<ICheckDepositData>;

export function getNewAndUpdateTransactions(
  transactions?: IEscrowWireDisbursementsData[]
): INewAndUpdateTransactions<IEscrowWireDisbursementsData>;

export function getNewAndUpdateTransactions(
  transactions?: IInternalTransferData[]
): INewAndUpdateTransactions<IInternalTransferData>;

export function getNewAndUpdateTransactions(
  transactions?: IManualCheckDisbursementData[]
): INewAndUpdateTransactions<IManualCheckDisbursementData>;

export function getNewAndUpdateTransactions(
  transactions?: IWireDepositData[]
): INewAndUpdateTransactions<IWireDepositData>;

//implementation
export function getNewAndUpdateTransactions(transactions?: any[]) {
  if ((transactions || []).some((element) => !!element.createdAt)) {
    const [newData, updateData] = partition(transactions || [], (transaction) => !transaction.createdAt);
    return { newData, updateData };
  }
  return { newData: transactions || [], updateData: [] };
}
